// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__bXiRE","choiceBoxes":"toolbarselects_choiceBoxes__3yNDG","simpleField":"toolbarselects_simpleField__2O-Te"};